import PortalIdParser from 'PortalIdParser';
/**
 * Same idea as ContentUtils Routes but avoids adding a ContentUtils dep to our consumers
 * if they do not have that already.
 */
export const getBrandIdentityUrl = ({
  tab,
  businessUnitId = 0
}) => {
  const url = `/settings/${PortalIdParser.get()}/brand-identity/brand/${businessUnitId}`;
  if (tab) {
    return `${url}/${tab}`;
  }
  return url;
};